/**
 * @author Daniel Aguirre
 * @file actions.js
 * @description EducationalCategory Actions
 */

// Constants
import {
  GET_ALL_EDUCATIONAL_CATEGORIES,
  CREATE_EDUCATIONAL_CATEGORY,
  UPDATE_EDUCATIONAL_CATEGORY,
  GET_EDUCATIONAL_CATEGORY_BY_ID,
  DELETE_EDUCATIONAL_CATEGORY_BY_ID
} from './constants';

/**
 * Call process to get all profiles list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALL_EDUCATIONAL_CATEGORYS
 */
export const getEducationalCategoriesArray = (data, callback) => ({
  type: GET_ALL_EDUCATIONAL_CATEGORIES,
  payload: { data },
  callback
});

/**
 * Call process to get profile by id
 * @param  { object } data - EducationalCategory Id
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ROL_BY_ID
 */
export const getEducationalCategoryById = (data, callback) => ({
  type: GET_EDUCATIONAL_CATEGORY_BY_ID,
  payload: { data },
  callback
});

/**
 * Call process to create profile
 * @param  { object } data - EducationalCategory Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of CREATE_EDUCATIONAL_CATEGORY
 */
export const createEducationalCategory = (data, callback) => ({
  type: CREATE_EDUCATIONAL_CATEGORY,
  payload: { data },
  callback
});

/**
 * Call process to update profile
 * @param  { object } data - EducationalCategory Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of UPDATE_EDUCATIONAL_CATEGORY
 */
export const updateEducationalCategory = (data, callback) => ({
  type: UPDATE_EDUCATIONAL_CATEGORY,
  payload: { data },
  callback
});

/**
 * Call process to delete profile
 * @param  { object } data - EducationalCategory Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of DELETE_EDUCATIONAL_CATEGORY_BY_ID
 */
export const deleteEducationalCategoryById = (data, callback) => ({
  type: DELETE_EDUCATIONAL_CATEGORY_BY_ID,
  payload: { data },
  callback
});
